import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import TextField from '@/modules/common/components/TextField';
import DialogForm from '@/modules/common/components/DialogForm';
import { withFetch } from '~/hocs/fetch';

const initialValues = {
    code: '',
    name: '',
};

const initialErrors = {
    code: '',
    name: '',
};

let abortController;

const DialogEdit = (props) => {
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState(initialErrors);
    const [fetching, setFetching] = useState(false);

    const clear = () => {
        setValues(initialValues);
        setErrors(initialErrors);
    };

    useEffect(() => {
        if (abortController) {
            abortController.abort();
        }
    }, []);

    useEffect(() => {
        if (props.selectedType) {
            setValues({
                code: props.selectedType.code,
                name: props.selectedType.name,
            });
        }
    }, [props.selectedType]);

    const handleChange = (prop) => (event) => {
        setValues({...values, [prop]: event.target.value});
    };

    const handleFocus = (prop) => () => {
        setErrors({...errors, [prop]: ''});
    };

    const handleSubmit = (event) => {
        abortController = new AbortController();

        event.preventDefault();
        setFetching(true);
        props.fetch.put(
            `/api/types/${props.selectedType.id}/`, {
                code: values.code,
                name: values.name
            },
            abortController
        ).then(({ok, data}) => {
            if (ok) {
                clear();
                props.onOk(data);
            }
            else {
                let _errors = {...initialErrors};
                _errors.code = (data.code) ? data.code[0] : '';
                _errors.name = (data.name) ? data.name[0] : '';
                setErrors(_errors);
            }
            setFetching(false);
        }).catch((error) => {
            if (error.name !== 'AbortError') {
                setFetching(false);
            }
        }).finally(() => {
            abortController = null;
        });
    };

    const handleClose = () => {
        props.setOpen(false);
        clear();
        props.setSelectedType(null);
    };

    return (
        <DialogForm title="Изменение типа" label="Изменить"
                    open={props.open} onSubmit={handleSubmit} onClose={handleClose}
                    disabled={fetching}
        >
            <>
                <TextField label="Код"
                           value={values.code} onChange={handleChange('code')}
                           error={errors.code.length > 0}
                           helperText={errors.code}
                           onFocus={handleFocus('code')}
                           autoFocus={true}
                />
                <TextField label="Название"
                           value={values.name} onChange={handleChange('name')}
                           error={errors.name.length > 0}
                           helperText={errors.name}
                           onFocus={handleFocus('name')}
                />
            </>
        </DialogForm>
    );
};

DialogEdit.propTypes = {
    selectedType: PropTypes.object,
    setSelectedType: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
};

let Component = DialogEdit;
Component = withFetch(Component);

export default Component;
